/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ExamSessionResponseOpenedAt } from './examSessionResponseOpenedAt';
import type { ExamSessionResponseOpenedBy } from './examSessionResponseOpenedBy';
import type { ExamSessionResponseClosedAt } from './examSessionResponseClosedAt';
import type { ExamSessionResponseClosedBy } from './examSessionResponseClosedBy';
import type { ExamSessionResponseTimeLimitMinutes } from './examSessionResponseTimeLimitMinutes';
import type { ExamSessionResponseAutoCloseAt } from './examSessionResponseAutoCloseAt';
import type { ExamSessionResponseTimeRemainingSeconds } from './examSessionResponseTimeRemainingSeconds';
import type { ExamSessionResponseAdmitted } from './examSessionResponseAdmitted';
import type { ExamSessionResponseBookingStatus } from './examSessionResponseBookingStatus';

/**
 * Response containing exam session state and caller's booking context.

When the caller is a student, `admitted` and `booking_status` are populated
from their booking so the frontend can derive the full exam gate state from
this single response without cross-referencing booking data.
 */
export interface ExamSessionResponse {
  openedAt?: ExamSessionResponseOpenedAt;
  openedBy?: ExamSessionResponseOpenedBy;
  closedAt?: ExamSessionResponseClosedAt;
  closedBy?: ExamSessionResponseClosedBy;
  timeLimitMinutes?: ExamSessionResponseTimeLimitMinutes;
  autoCloseAt?: ExamSessionResponseAutoCloseAt;
  timeRemainingSeconds?: ExamSessionResponseTimeRemainingSeconds;
  admitted?: ExamSessionResponseAdmitted;
  bookingStatus?: ExamSessionResponseBookingStatus;
}
